import { Logger, LoggerService } from "@Shared/logger";
import { PageSuiteOptions } from "./_models";
import { PageSuiteService } from "./services";
import { EventUtil } from "@Shared/utils";
import { APP_EVENTS } from "@Core";
import { OnReadyEvent } from "@Modules/event_module";
import { EngageService } from "@Modules/engage_module";






export class PageSuiteModuleClass {
    private Logger: Logger = LoggerService.createLogger("PageSuiteModule");


    constructor() {
        this.Logger.trace("****  CTOR ****");
        PageSuiteService.Instance.setup();
    }

    public async init(options: PageSuiteOptions): Promise<void> {
        this.Logger.trace("setting up PageSuite Module...", options);
        try {
            //this.setup();
            await PageSuiteService.Instance.init(options);
            

            return Promise.resolve();
        } catch (error) {
            throw error;
        }


    }

    private setup(): void {
        this.Logger.trace("setup");
        EventUtil.listenForEvent(APP_EVENTS.onAuthDetermined, (event) => {
            this.Logger.trace("onAuthDetermined", event);
        });

        EventUtil.listenForEvent(APP_EVENTS.onEntitlementsDetermined, async (event) => {
            this.Logger.trace("onEntitlementsDetermined", event);
            await EngageService.Instance.handlePaywallShown();
        });

        //TODO: Clean this up. Need to rework onReady event and thus EntitlementDetermined event so i don't need all these ? check. Might want to not have any data in onReady and just rely on getting Entitlement in the repo.
        EventUtil.listenForEvent(APP_EVENTS.onReady, (event: OnReadyEvent) => {
            this.Logger.trace("onReady", event);
            const data = event;
            if(data.entitlement) {
                if(data.entitlement.mngSession && data.entitlement.mngSession.isEntitled) {
                    const modal = document.querySelector(".modal-scrollable");
                    if(modal) {
                        modal.remove();
                    }
                    const modalBackdrop = document.querySelector(".connext-modal-backdrop");
                    if(modalBackdrop) {
                        modalBackdrop.remove();
                    }
                    window['Connext']?.Run();
                }
                if(!window.psAuthorise){
                    this.Logger.error("psAuthorise is not defined on window");
                    return;
                }
                if(window.psAuthorise && data.entitlement.mngSession) {
                    //TODO: Clean this garbage ? up. Need to rework
                    if(data?.entitlement?.mngSession?.entitlementToken){
                        this.Logger.trace("Calling psAuthorise with entitlement token", data?.entitlement?.mngSession?.entitlementToken);
                        window.psAuthorise({idToken:data?.entitlement?.mngSession?.entitlementToken})
                    }
                }
            }
        });
    }

    private handleonReady(event: OnReadyEvent): void {
        this.Logger.trace("handleonReady", event);
    }

}


export const PageSuiteModule = new PageSuiteModuleClass();